import * as React from 'react';

export function Track(
  props: React.HTMLAttributes<SVGSVGElement> & { label: string },
) {
  return (
    <svg
      aria-label={props.label}
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="navigation-icon-track"
      {...props}
    >
      <path
        d="M20.5938 11.0488C20.5938 16.5717 16.1166 21.0488 10.5938 21.0488C5.0709 21.0488 0.59375 16.5717 0.59375 11.0488C0.59375 5.52598 5.0709 1.04883 10.5938 1.04883C16.1166 1.04883 20.5938 5.52598 20.5938 11.0488Z"
        fill="url(#paint0_linear_8981_5566)"
      />
      <g filter="url(#filter0_bi_8981_5566)">
        <path
          d="M22.1054 9.50049C22.9051 9.2503 23.6394 10.0355 23.3363 10.8166L18.4869 23.3129C18.1518 24.1764 16.9243 24.1597 16.6129 23.2874L14.7624 18.104C14.669 17.8425 14.4712 17.6317 14.2163 17.5218L9.22737 15.3721C8.37542 15.0049 8.43914 13.7763 9.3245 13.4993L22.1054 9.50049Z"
          fill="white"
          fillOpacity="0.5"
        />
        <path
          d="M22.2547 9.97768C22.6546 9.85258 23.0217 10.2452 22.8702 10.6358L18.0208 23.132C17.8533 23.5638 17.2395 23.5554 17.0838 23.1193L15.2332 17.9359C15.0933 17.5437 14.7966 17.2274 14.4142 17.0626L9.42523 14.9129C8.99926 14.7293 9.03112 14.115 9.4738 13.9765L22.2547 9.97768Z"
          stroke="white"
          strokeOpacity="0.2"
        />
      </g>
      <defs>
        <filter
          id="filter0_bi_8981_5566"
          x="7.12305"
          y="7.95312"
          width="17.7832"
          height="17.498"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="0.75" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_8981_5566"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_8981_5566"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.5" />
          <feGaussianBlur stdDeviation="0.25" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_8981_5566"
          />
        </filter>
        <linearGradient
          id="paint0_linear_8981_5566"
          x1="10.5938"
          y1="1.04883"
          x2="10.5937"
          y2="17.5488"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FF83" stopOpacity="0.05" />
          <stop offset="1" stopColor="#00E786" />
        </linearGradient>
      </defs>
    </svg>
  );
}
